// extracted by mini-css-extract-plugin
module.exports = {"main":"FirstScreen_main__2Bv_2","button":"FirstScreen_button__2Vosg","mines":"FirstScreen_mines__22hil"};